module.exports = __webpack_public_path__ + "media/images/emblems/Port-coat_of_arms-cdec3472701e18b0c603881b90e5dfb4.svg";